export default class ConfigModel{
        version : string = "EXTERNAL";
        currentEnv : string = "DEV";
        salarysimService_LOCAL : string = "";
        salarysimService_DEV : string =  "";
        salarysimService_QA : string = "";
        salarysimService_PROD : string = "";
        translationService_LOCAL : string = "";
        translationService_DEV : string =  "";
        translationService_QA : string = "";
        translationService_PROD : string = "";
}